import { Formik, Form } from 'formik';
import React, { useMemo } from 'react';
import usersValidationSchema from './validationSchema';
import Input from 'component/atom/forms/input/input/Input';
import Select from 'component/atom/forms/select/select/Select';
import styles from './UsersForm.module.scss';
import { useFetch } from 'hooks/useFetch';
import { roleEndpoints, userEndpoints } from 'hooks/endpoints';
import { usePost } from 'hooks/usePost';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from 'app-context/user/UserContext';
import Loader from 'component/atom/loader/Loader';
import toast from 'react-hot-toast';
import { useToast } from 'app-context/toasterContext/ToastContext';
const UserForm = ({ id, data, isFetching, formRef, AddUser, EditUser }) => {
  const { updateProfileImage } = useUserContext();
  const { open: showToast } = useToast();
  const navigate = useNavigate();

  const { data: roles, isFetching: isFetchingRoles } = useFetch(
    ['getRoles'],
    roleEndpoints?.getRoles()
  );

  const fetchedData = data?.data?.user?.[0];
  const initialvalues = {
    firstName: fetchedData?.firstName || '',
    lastName: fetchedData?.lastName || '',
    displayEmail: fetchedData?.displayEmail || '',
    username: fetchedData?.username || '',
    department: fetchedData?.department || '',
    mobile: fetchedData?.mobile || '',
    phone: fetchedData?.phone || '',
    roleId: fetchedData?.roleId,
    ...(!id && { password: fetchedData?.password || '' }),
  };
  const rolesOptions = useMemo(
    () =>
      roles?.data?.map((val) => ({
        value: val.roleId,
        label: val.roleName,
      })),
    [roles]
  );

  const handleSubmitForm = (values) => {
    const userUpdates = { ...values };
    if (id) {
      EditUser(
        {
          url: userEndpoints?.editUser(id),
          data: values,
          method: 'Put',
        },
        {
          onSuccess: (data) => {
            if (
              data?.response?.userMessage ===
              'Email or username already exists.'
            ) {
              // showToast(data?.response?.userMessage, 'error');
              // navigate(-1);
            } else {
              updateProfileImage(null, id, userUpdates);
              // showToast('User updated successfully!', 'add');
              navigate(-1);
            }
          },
          onError: (error) => {
            // showToast('Something went wrong while updating.', 'error');
            // navigate(-1);
          },
        }
      );
    } else {
      AddUser(
        {
          url: userEndpoints?.createUser(),
          data: values,
        },
        {
          onSuccess: (data) => {
            if (
              data?.data?.userMessage === 'Email or username already exists.'
            ) {
              // showToast(data?.data?.userMessage, 'error');
            } else {
              updateProfileImage(null, null, userUpdates);
              // showToast('User added successfully!', 'add');
              navigate(-1);
            }
          },
          onError: () => {
            // showToast('Something went wrong while adding user.', 'error');
          },
        }
      );
    }
  };
  if (isFetching) {
    return <Loader isComponent />;
  }
  return (
    <Formik
      initialValues={initialvalues}
      validationSchema={usersValidationSchema(id)}
      enableReinitialize={true}
      onSubmit={(values) => {
        handleSubmitForm(values);
      }}
      innerRef={formRef}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
      }) => {
        return (
          <Form className={styles.formCont}>
            <div className={styles.cont}>
              <div className={styles.subCont}>
                <Input
                  label="First Name"
                  placeholder="Enter First Name"
                  name="firstName"
                  value={values.firstName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.firstName}
                  touched={touched.firstName}
                />
                <Input
                  label="Last Name"
                  placeholder="Enter Last Name"
                  name="lastName"
                  value={values.lastName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.lastName}
                  touched={touched.lastName}
                />
                <Input
                  label="Email Address"
                  placeholder="Enter Email"
                  name="displayEmail"
                  value={values.displayEmail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.displayEmail}
                  touched={touched.displayEmail}
                  disabled={id}
                />
                <Input
                  label="Department"
                  placeholder="Enter Department"
                  name="department"
                  value={values.department}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.department}
                  touched={touched.department}
                />
                <Input
                  label="Username"
                  placeholder="Enter Username"
                  name="username"
                  value={values.username}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.username}
                  touched={touched.username}
                  disabled={id}
                />{' '}
                <Input
                  label="Mobile"
                  placeholder="Enter mobile"
                  name="mobile"
                  value={values.mobile}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.mobile}
                  touched={touched.mobile}
                  // inputType="number"
                />{' '}
                <Input
                  label="Phone"
                  placeholder="Enter Phone"
                  name="phone"
                  value={values.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.phone}
                  touched={touched.phone}
                  // inputType="number"
                />
                {!id && (
                  <Input
                    label="Password"
                    placeholder="Enter Password"
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.password}
                    touched={touched.password}
                    inputType="password"
                  />
                )}
                {values.roleId != 0 && (
                  <Select
                    label="Role"
                    placeholder="Select Role"
                    name="roleId"
                    value={values.roleId}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.roleId}
                    touched={touched.roleId}
                    isLoading={isFetchingRoles}
                    options={rolesOptions}
                  />
                )}
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default UserForm;
